import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { PolicySequencesTab } from "../../../../../emailSequences/components/PolicySequencesTab";

export const LifeInsuranceSequencesRoutes = [
  {
    path: "/life-insurance-policy/:customerId/sequences/:customerPolicyId",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.LIFE_AND_FINCANCIAL]}>
        <PolicySequencesTab />
      </AuthorizedRoute>
    ),
  },
];
